/* No box of its own: fixed/absolute children keep their containing blocks, and only [data-motion] children move. */
.presence { display: contents; }
